module.exports = __webpack_public_path__ + "assets/best-sales-recruiters-los-angeles-2.447aa4a2.png";